var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.457,
    height: 17.457,
    viewBox: "0 0 17.457 17.457",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fb-ico",
    d: "M15.107,0H2.354A2.352,2.352,0,0,0,0,2.352V15.1a2.352,2.352,0,0,0,2.352,2.352H8.644l.011-6.238H7.034a.382.382,0,0,1-.382-.381L6.644,8.827a.382.382,0,0,1,.382-.384H8.644V6.5a3.174,3.174,0,0,1,3.389-3.483h1.651a.382.382,0,0,1,.382.382V5.1a.382.382,0,0,1-.382.382H12.67c-1.094,0-1.306.52-1.306,1.283V8.443h2.4a.382.382,0,0,1,.38.427l-.238,2.011a.382.382,0,0,1-.38.337H11.375l-.011,6.238h3.742A2.352,2.352,0,0,0,17.459,15.1V2.352A2.352,2.352,0,0,0,15.107,0Z",
    transform: "translate(-0.002)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIco);
export default __webpack_public_path__ + "static/media/fb-ico.477e6cb6d3f35f6a7b13f0880a5e6f86.svg";
export { ForwardRef as ReactComponent };